
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { SIMTemplateSelect } from "@/api/api-basic";
@Component({
  components: {}
})
export default class PiCardTips extends Vue {
  private versionData: objAny = {
    fileUrl: "",
    drive: "",
    driveXp: "",
    net: ""
  }; // 发卡插件版本
  private fileName = "pilot";

  async download(businessType: number): Promise<void> {
    const ret = await SIMTemplateSelect({ businessType: businessType });
    if (ret.status === this.$config.apiStatus) {
      if (businessType == 6) {
        this.versionData.fileUrl = this.$config.fileImg + ret.data[0];
      } else if (businessType == 7) {
        this.versionData.drive = this.$config.fileImg + ret.data[0];
      } else if (businessType == 8) {
        this.versionData.driveXp = this.$config.fileImg + ret.data[0];
      } else if (businessType == 9) {
        this.versionData.net = this.$config.fileImg + ret.data[0];
      }
    }
  }
  mounted(): void {
    this.download(6);
    this.download(7);
    this.download(8);
    // this.download(9);
  }
}
